import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import  codes  from '@/f1/codes';
import { api } from '@/f1/service';
import custom from '@/f1/custom';
import Language from './language';

//restful api
// import { wmds_v2 as ws } from '@/f1/service/api'

//i18n_data
import fields from './i18n_data'
import i18n_data from '@/component/i18n_data';

export default {
  components : { DatePicker, Language },
  data: () => {
    return {
      custom,
      codes,
      so : Object.assign({}, codes.DEFAULT_OPT, { opt : {} }),
      search : { target: 'detect', cmd : 'list', body: { and: [{name : 'is_del', value: false, op : '='}], or: [], sort: [{ name: 'id', op : 'desc'}] } }
    }
  },
  computed: {
    level() { return this.so.opt.level; },
    type() { return this.so.opt.type; },
    fields() { return fields.i18n_fields[this.i18n || 'EN']; },
    startRow : function() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    rowCount: function() { return this.so.totalRows || 0; }
  },
  watch: {
  },
  methods: {
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;
      if(!v) { opt[`${k}_sd`] = undefined; opt[`${k}_ed`] = undefined; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt);
    },
    set_op(k, v) {
      if(k.endsWith('_count')) {
        return { name : k, value : 0, op :  v == true ? '>' : '<=' }
      } else if(k.endsWith('_id')) {
        return { name : k, value : Number(v), op :  '=' }
      }
      return { name : k, value : `%${v}%`, op : 'like' }
    },
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['created_at_ed'] = moment().add(1, "day");
        this.so.opt['match_type'] = 'and';
        this.so.sv = ''
      } else { this.reset(); }
    },
    reset() { this.so = Object.assign({}, codes.DEFAULT_OPT, { opt : {} }); this.refresh(); },
    refresh() { this.$refs._list && this.$refs._list.refresh(); },
    getItems: function(ctx) { return this.load(ctx); },
    load(ctx = {}) {
      this.loading = true
        let so = {
          target : 'detect', cmd : 'list',
          body : {
            sort : [{ name : "id", op : "desc" }],
            or : [],
            and : []
          },
          offset : (this.so.currentPage -1 || 0) * Number(this.so.perPage), limit: Number(this.so.perPage), // 10 은 나중에 변수 처리해야함.
        }

        if(['created_at'].indexOf(ctx.sortBy) > -1) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
        if(this.$route.params && this.$route.params.site_id) { so.body.and.push(this.set_op('site_id', this.$route.params.site_id, so)); }

        if(this.so.adv && this.so.opt) {
          var k = Object.keys(this.so.opt)
          for (let i = 0; i < k.length; i++) {
            if(k[i] == 'match_type') { continue; }
            let cond = undefined;
            let preprocessing = false

            switch (k[i]) {
              case 'created_at_sd':
                if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
                cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
                break;
              case 'created_at_ed':
                if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
                cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
                break;
              case 'type':
                preprocessing = true
                this.so.opt[k[i]].forEach(r => {
                  so.body.or.push({ name : k[i], value : r, op : "=" })
                });
                break;
              case 'level':
                preprocessing = true
                this.so.opt[k[i]].forEach(r => {
                  if(r == 'high') {
                    so.body.or.push({ name : k[i], value : 'H', op : "=" })
                    so.body.or.push({ name : k[i], value : 'W', op : "=" })  
                    so.body.or.push({ name : k[i], value : 'N', op : "=" })
                  }
                  if(r == 'medium') {
                    so.body.or.push({ name : k[i], value : 'S', op : "=" })
                  }
                  if(r == 'row') {
                    so.body.or.push({ name : k[i], value : 'R', op : "=" })
                  }
                });
                break;
              default:
                cond = this.set_op(k[i], this.so.opt[k[i]]);
                break;
            }
            if(!preprocessing) {
              if(cond.value == '%%' || cond.value === '') { continue; }
              if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
              else { so.body.or.push(cond) }
            }

          }
        } else {
          if(this.so.sk && this.so.sv != undefined) { so.body.and.push(this.set_op(this.so.sk, this.so.sv, so)); }
        }
      return api.wmds.WMDS(so).then(rs => { this.so.totalRows = rs.total; this.$parent.$emit('loading', false); this.loading = false; return rs.body ? rs.body : []; })
      //Todo: 확인완료
      // return ws.detect.list(so).then(rs => { this.so.totalRows = rs.total; this.$parent.$emit('loading', false); this.loading = false; return rs.body ? rs.body : []; })
        .catch(e => this.$toastr.e(e.data ? `${i18n_data._i18n_error.load_failed[this.i18n]}` :  e.data.message || e.data.title ? e.data.title : e.statusText))
    },
    detail: function(item) { this.$parent.$emit('loading', true); this.$router.push(`detect/${item.id}`); },
  },
  created: function() {   console.log('pattern.vue', 'created');},
  destroyed: function() { console.log('pattern.vue', 'destroyed'); },
  mounted: function() { console.log('pattern.vue', 'mounted'); },
}
